"use client"

import { useEffect, useState } from "react"
import Script from "next/script"
import { CONSENT_CHANGED_EVENT, getCookieConsent } from "@/lib/consent"

// No placeholder fallback: when NEXT_PUBLIC_GA_ID is unset we render nothing
// instead of baking a fake measurement ID into the build.
const GA_ID = process.env.NEXT_PUBLIC_GA_ID

export default function Analytics() {
  const [consented, setConsented] = useState(false)

  useEffect(() => {
    const sync = () => setConsented(getCookieConsent() === "accepted")
    sync()
    // React to accept/decline in the same session, and to consent changed in
    // another tab.
    window.addEventListener(CONSENT_CHANGED_EVENT, sync)
    window.addEventListener("storage", sync)
    return () => {
      window.removeEventListener(CONSENT_CHANGED_EVENT, sync)
      window.removeEventListener("storage", sync)
    }
  }, [])

  // Only load Google Analytics in production, when a real measurement ID is
  // configured, AND the user has explicitly accepted cookies.
  if (process.env.NODE_ENV !== "production") return null
  if (!GA_ID) return null
  if (!consented) return null

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}', {
            page_path: window.location.pathname,
            anonymize_ip: true
          });
        `}
      </Script>
    </>
  )
}
